import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { LoginState } from './types';
import { RootState } from '../types';

// 一番最初にレンダリングされたときの状態を設定
export const state: LoginState = {
    isAuth: false,
    status: false,
};

const namespaced: boolean = true;

export const login: Module<LoginState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};

